import {DiscoveryUnitTabPresented, DiscoveryUnitTabSelected} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {SkillsHubAvailableFiltersSubUnit} from '@udemy/react-discovery-units';

interface SkillsHubUnitItem {
    id: number;
}

export const getTabTrackingContext = (uiRegion: string) => ({
    onTabImpression: (
        subUnit: SkillsHubAvailableFiltersSubUnit<SkillsHubUnitItem>,
        index: number,
    ) => {
        Tracker.publishEvent(
            new DiscoveryUnitTabPresented({
                topic: {
                    id: subUnit.source_object_id,
                    title: subUnit.title ?? '',
                },
                position: index,
                uiRegion,
            }),
        );
    },
    onTabSelect: (subUnit: SkillsHubAvailableFiltersSubUnit<SkillsHubUnitItem>, index: number) => {
        Tracker.publishEvent(
            new DiscoveryUnitTabSelected({
                topic: {id: subUnit.source_object_id, title: subUnit.title},
                position: index,
                uiRegion,
            }),
        );
    },
});
